// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsImagingParameters_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M19.7843 0H20.9477L21.7001 3.0098C22.3327 3.10686 22.943 3.27188 23.5231 3.49715L25.6786 1.26797 26.6861 1.84966 25.8327 4.83291C26.3238 5.22816 26.7711 5.6755 27.1664 6.16654L30.1496 5.31316 30.7313 6.32067 28.5023 8.47592C28.7277 9.05631 28.8928 9.6668 28.9899 10.2997L31.9994 11.0521V12.2154L28.9899 12.9678C28.8928 13.6007 28.7277 14.2112 28.5023 14.7916L30.7313 16.9469 30.1496 17.9544 27.1664 17.101C26.7712 17.5919 26.3239 18.0392 25.833 18.4343L26.6865 21.4178 25.679 21.9995 23.5235 19.7702C23.0354 19.9598 22.5261 20.1067 22 20.2063V18.4197C25.0628 17.6813 27.3382 14.9232 27.3382 11.6337 27.3382 7.77864 24.2131 4.65347 20.358 4.65347 17.0655 4.65347 14.3054 6.93304 13.57 10H11.7934C11.893 9.47386 12.0399 8.96444 12.2295 8.4763L10 6.32059 10.5817 5.31308 13.5655 6.16662C13.9605 5.67583 14.4076 5.22869 14.8984 4.83359L14.0448 1.84966 15.0523 1.26797 17.208 3.49745C17.7884 3.27202 18.3989 3.1069 19.0318 3.0098L19.7843 0ZM13 18H14V20H13V18Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 12H20V32H0V12ZM14 14H18V15H16L15 17V16L14 14ZM15 17H18V18H15V17ZM11 15V14H9L8 16H7L7.66667 18H9L8 20H10V18H9L10 15H11ZM10 22L11 20H13L12 22H16V20H18V30H2V22H5L4 20H7V22H10ZM13 18H11V16H12L13 18ZM2 18H6V16H5V17H2L3 15H5V14H2V17V18Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsImagingParameters is a generated icon component.
 */
let IconRmsImagingParameters = IconRmsImagingParameters_1 = class IconRmsImagingParameters extends IconBaseElement {
    render() {
        return html `${IconRmsImagingParameters_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsImagingParameters.icons = new Map([
    ['s8', _s32IconSvg],
    ['s12', _s32IconSvg],
    ['s16', _s32IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconRmsImagingParameters = IconRmsImagingParameters_1 = __decorate([
    customElement('zui-icon-rms-imaging-parameters')
], IconRmsImagingParameters);
export { IconRmsImagingParameters };
